<template>
  <div class="flex-row-base" @mouseover="onMouseover" @mouseleave="onMouseout">
    <v-icon small class="pr-2">mdi-phone-message</v-icon>
    <div>
      <span class="ui-text">Follow Up on </span
      ><span class="bold">{{ doc.followUp | date }}</span>
    </div>
    <v-spacer></v-spacer>
    <HiDatePicker future @pick="pickFollowUp">
      <span class="ui-text-clickable" v-if="isMouseover">Reschedule</span>
    </HiDatePicker>
    <span
      class="ui-text-clickable px-1"
      v-if="isMouseover"
      @click="cancelFollowUp"
      >Cancel</span
    >
    <span
      class="ui-text-clickable ml-3 bold"
      v-if="isMouseover"
      @click="$refs.editor.open()"
      >Feedback</span
    >
    <DLEditor
      ref="editor"
      title="Your Followup Feedback"
      @save="save"
    ></DLEditor>
  </div>
</template>

<script>
import DLEditor from "@/components/DiEditor";
import { api } from "@/api";
import { leads, updaters } from "@/db";
import hive from "@/hive";
import HiDatePicker from "@/components/HiDatePicker";
export default {
  name: "FollowUpDisplay",
  components: { HiDatePicker, DLEditor },
  props: {
    doc: {
      type: Object
    }
  },
  data() {
    return {
      isMouseover: false
    };
  },
  methods: {
    onMouseover() {
      this.isMouseover = true;
    },
    onMouseout() {
      this.isMouseover = false;
    },
    save(content) {
      this.sendComment(content);
      // console.log(content);
    },
    async cancelFollowUp() {
      if (
        await hive.confirm(
          "Are you sure you want to cancel the Following-Up for " +
            this.doc.name +
            "?"
        )
      ) {
        await updaters.lead(this.doc.id, "followUp", null);
      }
    },
    async sendComment(data) {
      const obj = {
        message: data,
        targetId: this.doc.id,
        action: "FU"
      };
      // console.log(data);
      const result = await api.leads.commentHandler(obj);
      if (result.error) {
        this.$refs.editor.error(result.error);
        // this.toast.error = "Server Error: " + result.error;
        // this.$refs.textarea.restart(true);
        // console.log(result.error);
      } else {
        await updaters.lead(this.doc.id, "followUp", null);
        if (this.$refs && this.$refs.editor) this.$refs.editor.close();
      }
      // this.toast.successful = "Submitted!";
      // this.$refs.textarea.restart();
    },
    pickFollowUp(date) {
      leads.followUp(this.doc.id, date);
    }
  }
};
</script>

<style scoped></style>
